<ziro-fieldset-header [legend]="'tkey;admin.email_templates.edit_view.name.header'">
  <ziro-text [fieldId]="'emailTemplateName'"></ziro-text>
  <ziro-text [fieldId]="'senderName'"></ziro-text>
</ziro-fieldset-header>
<ziro-fieldset-header [legend]="'tkey;admin.email_templates.edit_view.recipients.header'">
  <ziro-checkbox [fieldId]="'is360ViewEndUserRecipient'"></ziro-checkbox>
  <ziro-multi-text [fieldId]="'otherRecipients'"></ziro-multi-text>
</ziro-fieldset-header>
<ziro-fieldset-header [legend]="'tkey;admin.email_templates.edit_view.email_contents.header'">
  <ziro-text [borderRadOnlyLeft]="true" [fieldId]="'emailSubject'">
    <ziro-button
      [label]="'tkey;site_management.site.edit_custom_input_value.title'"
      [icon]="ziroIcons.ADD"
      [borderClass]="'input-text-end'"
      [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
      [dataAutomation]="'email-subject-insert-variable-button'"
      (clicked)="openVariableEditorModal('emailSubject')"
    ></ziro-button>
  </ziro-text>

  <ziro-code-area [fieldId]="'emailBody'">
    <ziro-button
      [label]="'tkey;site_management.site.edit_custom_input_value.title'"
      [icon]="ziroIcons.ADD"
      [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
      [cssClass]="'border-top-0 ms-2'"
      [dataAutomation]="'email-body-insert-variable-button'"
      (clicked)="openVariableEditorModal('emailBody')"
    ></ziro-button>
  </ziro-code-area>
</ziro-fieldset-header>

<legend>{{ 'tkey;admin.email_templates.edit_view.preview.header' | translate }}</legend>
<div class="row mb-2">
  <div class="ziro-forms-label text-lg-end col-form-label col-lg-3">
    <label>{{ 'tkey;admin.email_templates.edit_view.subject.label' | translate }}</label>
  </div>
  <div class="col-lg-9" data-automation="email-template-subject-preview">
    <div class="form-control font-light subject-preview" [innerHTML]="subjectHtmlPreview | escapeHtml"></div>
  </div>
</div>
<div class="row mb-4">
  <div class="ziro-forms-label text-lg-end col-form-label col-lg-3">
    <label>{{ 'tkey;admin.email_templates.edit_view.body.label' | translate }}</label>
  </div>
  <div class="col-lg-9" data-automation="email-template-body-preview">
    <div class="form-control font-light body-preview" [innerHTML]="bodyHtmlPreview | escapeHtml"></div>
  </div>
</div>
